import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import Switch from 'react-switch';
import { useDispatch, useSelector } from 'react-redux';
import SelectField from '../Formik/SelectField';
import { getAllSettings, setAdminInputValue } from '../../actions/adminActions';
import getDays from './days';

export default function GeneralSettings() {
  const dayRange = getDays(30);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllSettings());
  }, []);

  const remainderEmail = useSelector((state) => state.admin.email_on.value);
  const remainderEmailValue = remainderEmail == 'true';

  const allowedDays = useSelector((state) =>
    parseInt(state.admin.allowed_advance_days.value, 10)
  );
  const limitToDay = useSelector((state) =>
    parseInt(state.admin.limit_to_day.value, 10)
  );
  const viewDaysBack = useSelector((state) =>
    parseInt(state.admin.view_days_back.value, 10)
  );

  return (
    <div className="general-settings">
      <Formik
        initialValues={{
          allowed_advance_days: allowedDays,
          limit_to_day: limitToDay,
          view_days_back: viewDaysBack
        }}
      >
        <Form>
          <SelectField
            name="allowed_advance_days"
            label="Předem rezervovat dní"
            options={dayRange}
            onChangeValue={(name, value) =>
              dispatch(setAdminInputValue(name, value))
            }
          />
          <SelectField
            name="limit_to_day"
            label="Omezení na počet dní"
            options={dayRange}
            onChangeValue={(name, value) =>
              dispatch(setAdminInputValue(name, value))
            }
          />
          <SelectField
            name="view_days_back"
            label="Počet dní dozadu"
            options={dayRange}
            onChangeValue={(name, value) =>
              dispatch(setAdminInputValue(name, value))
            }
          />
          <div className="general-settings__switch">
            <span>Povolit emailové notifikace</span>
            <Switch
              name="email_on"
              height={20}
              checked={remainderEmailValue}
              onChange={(value) =>
                dispatch(setAdminInputValue('email_on', value))
              }
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
}
